import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UrlUtilsService } from '@rd/core/services/url-utils/url-utils.service';
import { AnzHomePageService } from '@rd/wl/anz/services/anz-home-page.service';

@Component({
  selector: 'rd-anz-benefits',
  templateUrl: './benefits.component.html',
  styleUrls: ['./benefits.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AnzBenefitsComponent {
  airlinePartnerIcon = this.urlUtilsService.imageUrl(
    '/images/airline-partner-icon.png',
  );
  cashBackIcon = this.urlUtilsService.imageUrl('/images/cashback-icon.png');
  giftCardIcon = this.urlUtilsService.imageUrl('/images/giftcard-icon.png');
  benefits = this.anzHomePageService.benefits;

  isEverydaySpendEnabled = this.anzHomePageService.isEverydaySpendEnabled;

  constructor(
    private urlUtilsService: UrlUtilsService,
    private anzHomePageService: AnzHomePageService,
  ) {}
}
